module.exports = __webpack_public_path__ + "img/enterprise__Solutions.a7668947.jpg";